<template>
  <div>
    <v-dialog max-width="600" v-model="isActive">
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          v-if="compact"
          v-bind="activatorProps"
          size="x-small"
          variant="flat"
          label
          style="
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-size: 8pt;
            border-radius: 4px;
            letter-spacing: 0.02em;
            padding: 0 8px;
            min-width: 0;
          "
          >Preview</v-btn
        >
        <v-btn v-else v-bind="activatorProps" variant="flat" color="button"
          >Preview
        </v-btn>
      </template>

      <template v-slot:default="{ isActive }">
        <v-card>
          <div class="pa-4">
            <h1>{{ category.name }}</h1>
            <p style="font-size: 14px">{{ category.description }}</p>
          </div>
          <div class="pa-4">
            <p style="font-size: 14px; font-weight: 600" class="mb-3">
              Saving this category will add the following posts to your library:
            </p>
            <div
              style="max-height: 40vh; overflow-y: auto; padding-right: 10px"
            >
              <div
                style="display: flex; flex-direction: column; gap: 10px"
                class="mb-4"
              >
                <v-card
                  class="pa-6 shadcard"
                  v-for="post in category.based_on"
                  :key="post.uid"
                  style="
                    display: grid;
                    grid-template-columns: 100px 1fr 50px;
                    align-items: center;
                    gap: 10px;
                  "
                >
                  <div>
                    <v-img
                      :src="post.content?.media?.[0]?.src"
                      width="100"
                      cover
                    ></v-img>
                  </div>
                  <div>
                    <p
                      style="
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        font-size: 11pt;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ post.commentary }}
                    </p>
                    <div class="d-flex align-center mt-2">
                      <v-icon size="small" color="muted" class="mr-1"
                        >mdi-calendar-outline</v-icon
                      >
                      <p style="font-size: 10pt" class="text-muted">
                        Last published:
                        <span class="font-weight-medium">{{
                          getDate(post.publishedAt)
                        }}</span>
                      </p>
                      <!-- <v-icon size="small" color="muted" class="ml-4 mr-1"
                        >mdi-heart-outline</v-icon
                      >
                      <p style="font-size: 10pt" class="text-muted">
                        Engagement: <span class="font-weight-medium">3.5%</span>
                      </p> -->
                    </div>
                  </div>
                  <div class="d-flex flex-column align-center" style="gap: 5px">
                    <v-btn
                      icon="mdi-eye-outline"
                      size="small"
                      variant="text"
                      @click="openPost(post.id)"
                    ></v-btn>
                    <v-btn
                      icon="mdi-delete-outline"
                      size="small"
                      @click="
                        $store.commit('removePostFromCategory', {
                          category: category.uid,
                          post: post.id,
                        })
                      "
                      variant="text"
                    ></v-btn>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text="Close" @click="isActive.value = false"></v-btn>
            <v-spacer></v-spacer>

            <v-btn
              v-if="!onboarding"
              variant="flat"
              color="button"
              :loading="importing"
              @click.stop="
                importing = true;
                $store.dispatch('keepCategory', category);
              "
              >Import & Save</v-btn
            >
            <v-btn
              v-if="onboarding"
              variant="flat"
              color="button"
              @click.stop="
                $emit('select', category);
                isActive.value = false;
              "
              >Select</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>
<script>
import { DateTime } from "luxon";
export default {
  props: {
    category: {
      type: Object,
      required: true,
    },
    onboarding: {
      type: Boolean,
      required: false,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      importing: false,
      isActive: false,
    };
  },
  methods: {
    open() {
      this.isActive = true;
    },
    openPost(urn) {
      window.open(`https://www.linkedin.com/feed/update/${urn}`, "_blank");
    },
    getDate(timestamp) {
      if (!timestamp) return "Unknown";
      let time = DateTime.fromMillis(timestamp);
      return time.toFormat("cccc DD @ T");
    },
  },
};
</script>
<style lang="scss" scoped>
.shadcard {
  border: 1px solid hsl(214.3 31.8% 91.4%);
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
</style>
